import React from 'react'
import { useFindMenu, useTealium } from '@next-nx/hooks'
import { WContainer, Breadcrumbs, MainTitle, WImage } from '@next-nx/shared-ui/atoms'
import { ListingSeoText, Page } from '@next-nx/shared-ui/organisms'
import styles from './MarchiTemplate.module.sass'
import { getTimestamp } from '@next-nx/utils'
import CircleBox from '../../molecules/CircleBox/CircleBox'
import Link from 'next/link'
import { MarcaVeicoloType } from '@next-nx/utils/types'

interface Props {
  className?: string
  pagina: any
  marcheVeicoli: MarcaVeicoloType[]
}

const MarchiTemplate = (props: Props) => {
  const { className = '', pagina = {}, marcheVeicoli } = props

  const marchiMenu = useFindMenu('pagina-marchi')
  const box1Menu = useFindMenu('box1', marchiMenu)
  const box2Menu = useFindMenu('box2', marchiMenu)

  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type: string = '', interazione: string = '') => {
    let dlObj = {}
    const action_timestamp = getTimestamp()

    switch (interazione) {
      case 'configurazione_personalizzata':
        dlObj = {
          virtual: 'action',
          action_name: 'configurazione_personalizzata',
          action_tech: 'click',
          action_type: 'richiedi_configurazione_personalizzata',
          action_timestamp,
          action_effect: 'richiedi_configurazione_personalizzata',
        }
        break
      default:
        dlObj
        break
    }
    linkDataLayer(dlObj)
  }

  return marcheVeicoli.length > 0 ? (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        <MainTitle label={pagina?.titolo} className={styles.title} />
        <div
          className={styles.descrizione}
          dangerouslySetInnerHTML={{ __html: pagina?.descrizione }}
        />
        <div className={styles.listingMarchi}>
          {marcheVeicoli.map(
            (n) =>
              n?.url && (
                <div className={styles.imageBox} key={n.pk}>
                  <Link href={n.url}>
                    <a>
                      <WImage
                        src={n?.image || ''}
                        alt={n?.nome}
                        title={n?.nome}
                        objectFit={'contain'}
                        layout={'fill'}
                        maxWidth={109}
                        maxHeight={70}
                      />
                    </a>
                  </Link>
                </div>
              )
          )}
        </div>
        <div className={styles.boxs}></div>
        {(box1Menu || box2Menu) && (
          <div className={styles.boxListing}>
            {!!box1Menu && (
              <CircleBox
                className={styles.box}
                item={box1Menu}
                onClick={() => handleTracking('', 'configurazione_personalizzata')}
              />
            )}
            {!!box2Menu && (
              <CircleBox
                className={styles.box}
                item={box2Menu}
                onClick={() => handleTracking('', 'configurazione_personalizzata')}
              />
            )}
          </div>
        )}
      </WContainer>

      {/* Commentato perchè ripetizione del testo sopra
      {!!pagina?.descrizione && <ListingSeoText text={pagina?.descrizione}> </ListingSeoText>}
      */}
    </Page>
  ) : (
    <></>
  )
}

export default MarchiTemplate
